import { IShopWholesaler } from '@cbgms/api'
import { UseWholesalerValidatorResult } from 'app/auth/components/hooks/use-wholesaler-validator-builder'
import { FC } from 'react'
import { defaultStepFormProps } from '../types.d'
import { OnboardingCredentialsFormMijnGrossier } from './MijnGrossierWholesalers/OnboardingCredentialsFormMijnGrossier'
import { OnboardingCredentialsFormDefault } from './Default/OnboardingCredentialsFormDefault'
import { isMijnGrossierOrMgNl, isVPOMAXBE } from 'utils/Ordersystems/utils'

export const OnboardingCredentialsForm: FC<
  defaultStepFormProps & {
    basePath: string
    onSubmit: (result: UseWholesalerValidatorResult) => void
    wholesaler?: IShopWholesaler
  }
> = props => {
  const { wholesaler } = props

  /*
    We need a wholesaler to continue onboarding.
  */
  if (!wholesaler) {
    return <>not yet supported</>
  }

  /*
    VPOM AX BE authenticate through MijnGrossier.
    Users known there MG credentials but not there AX credentials.
    We fetch AX credentials via MG to solve this issue.
  */
  if (isMijnGrossierOrMgNl(wholesaler) || isVPOMAXBE(wholesaler)) {
    return <OnboardingCredentialsFormMijnGrossier {...props} wholesaler={wholesaler} />
  }

  return <OnboardingCredentialsFormDefault {...props} wholesaler={wholesaler} />
}
